import {
  collection,
  deleteDoc,
  doc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import PropTypes from "prop-types";
import { docData } from "rxfire/firestore";

import { firestore } from "../firebase";
import { createdAt } from "../lib/timestamp";

export const collectionName = "project-slugs";

export const propTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

export const store = {
  getById: (id) => {
    const docRef = doc(firestore, collectionName, id);

    return docData(docRef, { idField: "id" });
  },
  update: (id, data) => {
    const docRef = doc(firestore, collectionName, id);

    return updateDoc(docRef, data).then(() => docRef);
  },
  delete: (id) => {
    const docRef = doc(firestore, collectionName, id);

    return deleteDoc(docRef).then(() => docRef);
  },
  write: (docData) => {
    const docRef = doc(collection(firestore, collectionName));

    return setDoc(docRef, { ...docData, ...createdAt() }).then(() => docRef);
  },
};
